import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'

/**
 * `organizations`: the list (deactivate / reactivate, #2673) and the creation
 * wizard; `contract`: what Depanneo sets for one organization (#3049).
 */
export type SuperAdminTabs = 'organizations' | 'contract'

const allowedTabs: SuperAdminTabs[] = ['organizations', 'contract']

/** The tabs before #3049, still in bookmarks and in older links. */
const LEGACY_TABS = new Map<unknown, SuperAdminTabs>([
  ['new', 'organizations'],
  ['existing', 'contract'],
])

export type SuperAdminSearch = {
  tab: SuperAdminTabs
  /** The organization « Contrat d'une organisation » acts on. */
  org?: string
  /** Opens the creation wizard: the switcher's « Nouvelle organisation » (#2818). */
  create?: true
}

export const Route = createFileRoute(
  '/_authenticated/(super-admin)/super-admin'
)({
  validateSearch: (search: Record<string, unknown>): SuperAdminSearch => {
    const { tab, org, create } = search
    // The wizard lives on « Organisations », whatever tab the link names.
    if (create === true) return { tab: 'organizations', create: true }
    const resolved = allowedTabs.includes(tab as SuperAdminTabs)
      ? (tab as SuperAdminTabs)
      : (LEGACY_TABS.get(tab) ?? 'organizations')
    return {
      tab: resolved,
      ...(typeof org === 'string' && org !== '' && { org }),
    }
  },
  beforeLoad: () => {
    requiredRoles([UserRole.SUPER_ADMIN])
  },
})
